import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { AppBar, IconButton, Stack, Toolbar } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import AccountPopover from './components/accountPopover';
import NotificationsPopover from './components/notificationPopover';
import RegionPopover from './components/regionPopover';

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 60;

const RootStyle = styled(AppBar)(({ theme }) => ({
	boxShadow: 'none',
	backdropFilter: 'blur(6px)',
	WebkitBackdropFilter: 'blur(6px)',
	backgroundColor: alpha(theme.palette.background.default, 0.72),
	[theme.breakpoints.up('lg')]: {
		width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
	},
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
	minHeight: APPBAR_MOBILE,
	[theme.breakpoints.up('lg')]: {
		minHeight: APPBAR_DESKTOP,
		padding: theme.spacing(0, 5),
	},
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
	onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
	return (
		<RootStyle>
			<ToolbarStyle className="primary-bg shadow-md">
				<IconButton
					onClick={onOpenSidebar}
					className="!bg-white"
					sx={{
						mr: 1,
						color: 'text.primary',
						display: { lg: 'none' },
					}}>
					<MenuOutlinedIcon></MenuOutlinedIcon>
				</IconButton>

				<Stack
					width="100%"
					direction="row"
					alignItems="center"
					justifyContent="flex-end"
					spacing={{ xs: 0.5, sm: 2 }}>
					{/* <LanguagePopover /> */}
					<RegionPopover />
					{/* <AdminNotificationPopover /> */}
					<NotificationsPopover />
					<AccountPopover />
				</Stack>
			</ToolbarStyle>
		</RootStyle>
	);
}
